import React from 'react';
import QRCodeSection from './QRCodeSection';

const QRCodeDisplayPage = () => {
    return (
        <div className="qr-display-page">
            <div className="qr-fullscreen-container">
                <div className="qr-ceremony-header">
                    <h1 className="ceremony-title font uppercase">
                        💒 Matrimonio Alessandro & Ylenia
                    </h1>
                    <h2 className="ceremony-subtitle font">
                        Lascia un messaggio speciale per gli sposi! 
                    </h2>
                </div>
                
                <QRCodeSection />
                
                <div className="ceremony-footer">
                    <p className="ceremony-instructions font-detail">
                        📱 <strong>Scansiona il QR code</strong> con la fotocamera del telefono
                        <br />
                        ✨ <strong>Scegli come lasciare il tuo messaggio:</strong> scritto, vocale o con foto
                        <br />
                        🎉 <strong>Il tuo messaggio apparirà in tempo reale</strong> per tutti gli ospiti!
                    </p>
                </div>
            </div>
        </div>
    );
};

export default QRCodeDisplayPage; 
